var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.item.hidden &&
    (_vm.$can("read", _vm.dict[_vm.item.path]) || _vm.hasFullAccess) &&
    _vm.userTermsOfUse
    ? _c(
        "li",
        [
          _vm.hasOneShowingChild(_vm.item.children, _vm.item) &&
          (!_vm.onlyOneChild.children || _vm.onlyOneChild.noShowingChildren) &&
          !_vm.item.alwaysShow
            ? [
                _vm.onlyOneChild.meta
                  ? _c("menu-link", {
                      attrs: {
                        to: _vm.resolvePath(_vm.onlyOneChild.path),
                        label: _vm.getTitle(_vm.onlyOneChild.meta.title),
                        icon: _vm.moduleIcon,
                        "fallback-icon":
                          _vm.onlyOneChild.meta.icon ||
                          (_vm.item.meta && _vm.item.meta.icon),
                        active:
                          _vm.resolvePath(_vm.onlyOneChild.path) ===
                          _vm.activeMenu,
                        collapsed: _vm.collapsed,
                      },
                      on: { select: _vm.linkClicked },
                    })
                  : _vm._e(),
              ]
            : [
                _vm.item.meta
                  ? _c("span", { staticClass: "sidebar-menu__group-title" }, [
                      _vm._v(_vm._s(_vm.item.meta.title)),
                    ])
                  : _vm._e(),
                _c(
                  "ul",
                  { staticClass: "sidebar-menu__list" },
                  _vm._l(_vm.item.children, function (child) {
                    return _c("sidebar-item", {
                      key: child.path,
                      attrs: {
                        "is-nest": true,
                        item: child,
                        "base-path": _vm.resolvePath(child.path),
                        "active-menu": _vm.activeMenu,
                        collapsed: _vm.collapsed,
                      },
                    })
                  }),
                  1
                ),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }